document.addEventListener('DOMContentLoaded', function() {
  const video = document.getElementById("productVideo");
  const playBtn = document.getElementById("playBtn");

  if (video && playBtn) {
    playBtn.addEventListener("click", function () {
      video.play();
      playBtn.style.display = "none";
    });

    video.addEventListener("play", function () {
      playBtn.style.display = "none";
    });

    video.addEventListener("pause", function () {
      playBtn.style.display = "block";
    });
  }

  document.querySelectorAll('.video-wrapper').forEach(function(wrapper){
    const video = wrapper.querySelector('video');
    const btn = wrapper.querySelector('.video-toggle-sound');

    if (video && btn) {
      btn.addEventListener('click', function(){
        if(video.muted){
          video.muted = false;
          btn.classList.add('unmuted');
          btn.setAttribute('aria-label', 'Mute video');
        } else {
          video.muted = true;
          btn.classList.remove('unmuted');
          btn.setAttribute('aria-label', 'Unmute video');
        }
      });
    }
  });

  const variantPickers = document.querySelectorAll("variant-radios, variant-selects");
  const mainImg = document.querySelector(".product__photo img");

  if (mainImg && variantPickers.length) {
    variantPickers.forEach((picker) => {
      picker.addEventListener("change", () => {
        const currentVariant = picker.currentVariant;
        if (currentVariant && currentVariant.featured_media) {
          const baseUrl = currentVariant.featured_media.preview_image.src.split("?v=")[0];
          const version  = currentVariant.featured_media.preview_image.src.split("?v=")[1] || "";

          const widths = [180, 320, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2048];
          const newSrcset = widths
            .map(w => `${baseUrl}?v=${version}&width=${w} ${w}w`)
            .join(", ");

          const newSrc = `${baseUrl}?v=${version}&width=720`;

          mainImg.src = newSrc;
          mainImg.srcset = newSrcset;
          mainImg.setAttribute("data-srcset", newSrcset);
          mainImg.setAttribute("data-zoom-gallery", `${baseUrl}?v=${version}&width=2048`);
          mainImg.alt = currentVariant.featured_media.alt || "";

          mainImg.style.opacity = 0;
          setTimeout(() => { mainImg.style.opacity = 1; }, 100);
        }
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
    const elements = document.querySelectorAll('.product-info-and-video');

    // Hide all elements initially
    elements.forEach(el => {
        el.style.display = 'none';
    });

    // Show elements on first mouse movement
    function showOnMouseMove() {
        // console.log("Mouse moved! Showing elements...");
        elements.forEach(el => {
            el.style.display = 'block'; // or 'flex' if your layout needs it
        });

        // Remove the event listener so it only triggers once
        document.removeEventListener('mousemove', showOnMouseMove);
    }

    document.addEventListener('mousemove', showOnMouseMove);
});

